import { useEffect, useRef, useState } from "react";
import { Play, Pause, RotateCcw, Timer } from "lucide-react";
import { Button } from "@/components/ui/button";

const KEY = "jdm_stopwatch";

const fmt = (ms) => {
  const t = Math.floor(ms / 1000);
  const h = String(Math.floor(t / 3600)).padStart(2, "0");
  const m = String(Math.floor((t % 3600) / 60)).padStart(2, "0");
  const s = String(t % 60).padStart(2, "0");
  return `${h}:${m}:${s}`;
};

export function Stopwatch() {
  const [state, setState] = useState(() => {
    try {
      const saved = JSON.parse(localStorage.getItem(KEY));
      if (saved) return saved;
    } catch (e) {}
    return { running: false, accumulated: 0, startedAt: null };
  });
  const [, setTick] = useState(0);
  const raf = useRef(null);

  useEffect(() => {
    localStorage.setItem(KEY, JSON.stringify(state));
  }, [state]);

  useEffect(() => {
    if (!state.running) return;
    const id = setInterval(() => setTick((t) => t + 1), 500);
    return () => clearInterval(id);
  }, [state.running]);

  const elapsed = state.accumulated + (state.running && state.startedAt ? Date.now() - state.startedAt : 0);

  const start = () => setState({ ...state, running: true, startedAt: Date.now() });
  const pause = () => setState({ running: false, accumulated: elapsed, startedAt: null });
  const reset = () => setState({ running: false, accumulated: 0, startedAt: null });

  return (
    <div className="flex items-center gap-2 rounded-md border border-border bg-card px-3 py-1.5" data-testid="stopwatch">
      <Timer className={`h-4 w-4 ${state.running ? "text-primary" : "text-muted-foreground"}`} />
      <span className="font-mono font-semibold tabular-nums text-sm sm:text-base w-[74px]" data-testid="stopwatch-time">{fmt(elapsed)}</span>
      {!state.running ? (
        <Button size="icon" variant="ghost" className="h-8 w-8" onClick={start} data-testid="stopwatch-start" title="Iniciar">
          <Play className="h-4 w-4 text-green-600" />
        </Button>
      ) : (
        <Button size="icon" variant="ghost" className="h-8 w-8" onClick={pause} data-testid="stopwatch-pause" title="Pausar">
          <Pause className="h-4 w-4 text-orange-500" />
        </Button>
      )}
      <Button size="icon" variant="ghost" className="h-8 w-8" onClick={reset} data-testid="stopwatch-reset" title="Reiniciar">
        <RotateCcw className="h-4 w-4 text-muted-foreground" />
      </Button>
    </div>
  );
}
